import React, { useId } from 'react';

export function Select({
  label,
  id = undefined,
  className = '',
  options = [],
  ...rest
}) {
  const autoId = useId();
  const inputId = id || autoId;

  return (
    <div className={`select-field ${className}`.trim()}>
      {label && (
        <label className="select-field__label" htmlFor={inputId}>
          {label}
        </label>
      )}
      <select id={inputId} className="select-field__control" {...rest}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
